// Local translations
export const T = {
  en_GB: {
    delete: "Delete",
    editPortfolioCost: "Edit Portfolio Cost",
    addPortfolioCost: "Add Portfolio Cost",
    editDescription: "Update the portfolio cost settings.",
    createDescription: "Create a new cost for the portfolio.",
    name: "Name",
    namePlaceholder: "e.g., Advisory Fee",
    nameRequired: "Name is required",
    whenToApply: "When to Apply",
    categoryRecurring: "Recurring",
    categoryDeposit: "Deposit",
    categoryRecurringDesc: "Ongoing cost charged periodically (e.g., advisory fee, platform fee)",
    categoryDepositDesc: "One-time cost charged when depositing products",
    valueType: "Value Type",
    percentage: "Percentage",
    amount: "Amount",
    percentageDesc: "Fee charged as a percentage of portfolio value",
    amountDesc: "Fixed fee amount in currency",
    brackets: "Brackets",
    bracketsDesc: "Define tiers based on portfolio value. First bracket starts at 0.",
    fromAccountValue: "From (account value)",
    feePct: "Fee (%)",
    feeAmount: "Fee (amount)",
    addBracket: "Add Bracket",
    maxBrackets: "(max 10)",
    invalidStartValue: "Invalid start value",
    invalidValue: "Invalid value",
    startValueNegative: "Start value cannot be negative",
    valueNegative: "Value cannot be negative",
    valueExceedsPct: "Percentage cannot exceed 100",
    valueExceedsAmount: "Value is too large",
    startValueTooLarge: "Start value is too large",
    startValueMustBeGreater: "Start value must be greater than previous bracket",
    firstBracketMustStartAtZero: "First bracket must start at 0",
    cancel: "Cancel",
    save: "Save",
    failedToSave: "Failed to save portfolio cost",
    bracket: "Bracket",
  },
  nb_NO: {
    delete: "Slett",
    editPortfolioCost: "Rediger porteføljekostnad",
    addPortfolioCost: "Legg til porteføljekostnad",
    editDescription: "Oppdater innstillingene for porteføljekostnaden.",
    createDescription: "Opprett en ny kostnad for porteføljen.",
    name: "Navn",
    namePlaceholder: "f.eks. Rådgivningshonorar",
    nameRequired: "Navn er påkrevd",
    whenToApply: "Når skal den gjelde",
    categoryRecurring: "Løpende",
    categoryDeposit: "Innskudd",
    categoryRecurringDesc:
      "Løpende kostnad som belastes periodisk (f.eks. rådgivningshonorar, plattformavgift)",
    categoryDepositDesc: "Engangskostnad som belastes ved innskudd",
    valueType: "Verditype",
    percentage: "Prosent",
    amount: "Beløp",
    percentageDesc: "Avgift som belastes som en prosent av porteføljeverdien",
    amountDesc: "Fast avgiftsbeløp i valuta",
    brackets: "Intervaller",
    bracketsDesc: "Definer nivåer basert på porteføljeverdi. Første intervall starter på 0.",
    fromAccountValue: "Fra (kontoverdi)",
    feePct: "Avgift (%)",
    feeAmount: "Avgift (beløp)",
    addBracket: "Legg til intervall",
    maxBrackets: "(maks 10)",
    invalidStartValue: "Ugyldig startverdi",
    invalidValue: "Ugyldig verdi",
    startValueNegative: "Startverdi kan ikke være negativ",
    valueNegative: "Verdi kan ikke være negativ",
    valueExceedsPct: "Prosent kan ikke overstige 100",
    valueExceedsAmount: "Verdien er for stor",
    startValueTooLarge: "Startverdi er for stor",
    startValueMustBeGreater: "Startverdi må være større enn forrige intervall",
    firstBracketMustStartAtZero: "Første intervall må starte på 0",
    cancel: "Avbryt",
    save: "Lagre",
    failedToSave: "Kunne ikke lagre porteføljekostnad",
    bracket: "Intervall",
  },
} as const;
